import { useEffect, useState } from "react";
import Modal from "react-modal";
import api from "../../services/api";
import ReactLoading from "react-loading";
import "./index.css";
import { usePluginspace } from "../../hooks/usePluginspace";
import { MainButton } from "../MainButton";
import { datetimeToDateBR } from "../../functions/mask";
import { ConfigType } from "../../contexts/AppConfigContext";

type ModalBookingProps = {
	isOpen: boolean;
	setIsOpen: (value: boolean) => void;
	booking: BookingType;
	config: ConfigType;
	action: (value:any) => void;
};

type HourType = {
    id: string;
    hour: string;
}


type BookingType = {
    id: string;
    name: string;
    phone: string;
    people: number;
    email: string;
    date: string;
    hour: HourType;
}

export function ModalBooking({ isOpen, setIsOpen, booking, config, action }: ModalBookingProps) {
	
	const { getToken } = usePluginspace();

	return (
		<Modal
			isOpen={isOpen}
			onRequestClose={() => setIsOpen(false)}
			className="modal-booking"
			contentLabel="Endereço para entrega"
			overlayClassName="overlay-modal"
			ariaHideApp={false}
		>
			<div className="modal-booking-content">
				<div className="modal-booking-body">
					<div className="booking-title">
						<h2>Cancelamento</h2>
						<i className="fa fa-times" onClick={() => {setIsOpen(false)}}></i>
					</div>
					<p>Deseja cancelar essa reserva?</p>
					<div className="booking-box">
						<div className="booking-info">
							<div className="row">
								<b>Data</b>
								<p style={{color: '#6E7586'}}>{datetimeToDateBR(booking.date)}</p>
								<p style={{color: '#6E7586'}}>{booking.hour.hour}</p>
							</div>
							<b>{booking.people} {booking.people > 1 ? 'pessoas' : 'pessoa' }</b>
							<b>{booking.name}</b>
							<div className="row">
								<p style={{color: '#6E7586'}}>{booking.phone}</p>
								<p style={{color: '#6E7586'}}>{booking.email}</p>
							</div>
						</div>
                    </div>
					<div className="button">
						<div style={{width: '60%'}}>
							<MainButton
								color={
									config?.webappcolor.fontbutton
										? config.webappcolor.fontbutton
										: "#636363"
								}
								backgroundColor={
									config?.webappcolor.webappbutton
										? config.webappcolor.webappbutton
										: "#EAEAEA"
								}
								text="Cancelar reserva"
								onClick={() => action(booking.id)}
							/>
						</div>
					</div>
				</div>
			</div>
		</Modal>
	);
}
